import React, { useState, useEffect, useRef } from "react";
import "../css/earthstyle.css";

import Space1 from "../components/earth/01_Space1"
import Space2 from "../components/earth/02_Space2"
import Sky1 from "../components/earth/03_Sky1"
import Sky2 from "../components/earth/04_Sky2";
import Earth from "../components/earth/05_Earth";
import Underground from "../components/earth/06_Underground";

import LanguageSelector from "../components/LanguageSelector";
import coinIcon from "../images/assets/shared/R_COIN.svg"

import SocialDrawer from "../components/social-drawer/SocialDrawer";


const layers = [
    {
        id: "space1",
        bg: "linear-gradient(to bottom, #310980 0%, #6620bc 100%)",
    },
    {
        id: "space2",
        bg: "linear-gradient(to bottom, #6620bc 0%, #53bbe2 100%)",
    },
    {
        id: "sky1",
        bg: "linear-gradient(to bottom, #53bbe2 0%, #acdef1 100%)",
    },
    {
        id: "sky2",
        bg: "linear-gradient(to bottom, #acdef1 0%, #ffffff 100%)",
    },
    {
        id: "earth",
        bg: "linear-gradient(to bottom, #4c2c42 0%, #683547 100%)"
    },
    {
        id: "underground",
        bg: "linear-gradient(to bottom, #683547 0%, #7a3a4a 100%)"
    }
]

export default function EarthLayers() {
    const [activeLayer, setActiveLayer] = useState(0);
    const [coinsCollected, setCoinsCollected] = useState(0);
    const [collectedCoinIds, setCollectedCoinIds] = useState([]);
    const [flyingCoins, setFlyingCoins] = useState([]);
    const counterRef = useRef(null);

    useEffect(() => {
        const observers = layers.map((layer, i) => {
            const el = document.getElementById(layer.id);
            if (!el) return null;

            const obs = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) setActiveLayer(i);
                },
                { threshold: 0.4 }
            );

            obs.observe(el);
            return obs;
        });

        return () => observers.forEach((o) => o?.disconnect());
    }, []);

    const playCoinSound = () => {
        try {
            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            if (!AudioContextClass) return;

            const audioContext = new AudioContextClass();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.type = "triangle";
            oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
            oscillator.frequency.exponentialRampToValueAtTime(1320, audioContext.currentTime + 0.08);

            gainNode.gain.setValueAtTime(0.001, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.08, audioContext.currentTime + 0.01);
            gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.18);

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.start();
            oscillator.stop(audioContext.currentTime + 0.18);

            oscillator.onended = () => {
                audioContext.close();
            };
        } catch (error) {
            console.warn("Coin sound could not be played: ", error);
        }
    };

    const handleCoinCollect = (coinId, targetElement) => {
        if (!targetElement || collectedCoinIds.includes(coinId) || !counterRef.current) return;

        const coinRect = targetElement.getBoundingClientRect();
        const counterRect = counterRef.current.getBoundingClientRect();
        const flyingCoinId = `${coinId}-${Date.now()}`;

        setFlyingCoins((prev) => [
            ...prev,
            {
                id: flyingCoinId,
                startX: coinRect.left + coinRect.width / 2,
                startY: coinRect.top + coinRect.height / 2,
                endX: counterRect.left + counterRect.width / 2,
                endY: counterRect.top + counterRect.height / 2,
            }
        ]);

        setCollectedCoinIds((prev) => [...prev, coinId]);
        setCoinsCollected((prev) => prev + 1);
        playCoinSound();

        window.setTimeout(() => {
            setFlyingCoins((prev) => prev.filter((coin) => coin.id !== flyingCoinId));
        }, 700);
    };

    return (
        <>
            <SocialDrawer />

            <div className={'coin-counter-container'} ref={counterRef}>
                <img src={coinIcon} alt="" className="coin-counter-icon" />
                <span className={'coin-counter'}>{coinsCollected}</span>
            </div>

            {flyingCoins.map((coin) => (
                <img
                    key={coin.id}
                    src={coinIcon}
                    alt=""
                    className="flying-coin"
                    style={{
                        "--start-x": `${coin.startX}px`,
                        "--start-y": `${coin.startY}px`,
                        "--end-x": `${coin.endX}px`,
                        "--end-y": `${coin.endY}px`,
                    }}
                />
            ))}

            <div className="earth-layers">

                <Space1
                    layer={layers[0]}
                    collectedCoinIds={collectedCoinIds}
                    onCoinCollect={handleCoinCollect}
                />
                <Space2 layer={layers[1]}
                    collectedCoinIds={collectedCoinIds}
                    onCoinCollect={handleCoinCollect}
                />
                <Sky1 layer={layers[2]}
                      collectedCoinIds={collectedCoinIds}
                      onCoinCollect={handleCoinCollect}
                />
                <Sky2 layer={layers[3]}
                      collectedCoinIds={collectedCoinIds}
                      onCoinCollect={handleCoinCollect}
                      isActive={activeLayer === 3}
                />
                <Earth layer={layers[4]}
                       collectedCoinIds={collectedCoinIds}
                       onCoinCollect={handleCoinCollect}
                />
                <Underground layer={layers[5]}
                      collectedCoinIds={collectedCoinIds}
                      onCoinCollect={handleCoinCollect}
                      isActive={activeLayer === 5}
                />
            </div>
        </>
    );
}